import { computed, toValue } from 'vue';
import { useQuery, useMutation, useQueryClient } from '@tanstack/vue-query';
import api from './api';

export const useUserById = (id) => {
  return useQuery({
    queryKey: ['users', id],
    queryFn: () => api.getUserById(toValue(id)),
    enabled: computed(() => !!id.value),
  });
};

export const useBlockUserById = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (userId) => api.blockUserById(userId),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['users', variables] });
      queryClient.invalidateQueries({ queryKey: ['supplier-users'] });
    },
  });
};

export const useUnblockUserById = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (userId) => api.unblockUserById(userId),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['users', variables] });
      queryClient.invalidateQueries({ queryKey: ['supplier-users'] });
    },
  });
};

export const useUserRoles = (id) => {
  return useQuery({
    queryKey: ['user-roles', id],
    queryFn: () => api.getUserRoles(toValue(id)),
    enabled: computed(() => !!id.value),
  });
};

export const useUpdateUserRole = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => api.updateUserRole(data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['users', variables.user_id] });
      queryClient.invalidateQueries({ queryKey: ['user-roles', variables.user_id] });
      queryClient.invalidateQueries({ queryKey: ['supplier-users'] });
    },
  });
};
